<template>
    
    <div class="inProduct_list" >


            <BannerIn :bannerUrl="bannerUrl" :positionInfo="positionInfo" />
            <NavIn :inNavInfo="inNavInfo"  />
            <!-- <template  v-if="productList && productList.length>0">          
            </template> -->
           <!-- <template v-else>
                <section class="inProductBox">
                        <div class="wrapper">暂无数据</div>
                </section>        
            </template> -->
            <section class="inSpecialProductBox">
                <div class="inSpecialProductLeft">
                    <div class="title1">{{isZhong?'在中国，每十个TEC传感器中就有三个':'There are three TEC sensors in every ten in China'}}</div>
                    <div class="title2">{{isZhong?'TEC传感器':'TEC SENSORS'}}</div>
                    <div class="imgBox">
                        <div class="imgBg"><img src="./images/02.jpg" /></div>
                        <div class="img" v-if="productList && productList.length>0">
                          <swiper :options="specialSwiperOption" ref="special">
                              <swiper-slide class="specialSwiper_item" v-for="item in productList" :key="item.contentid">
                                  <img :src="$root.$TEMP_URL+item.ico" />
                              </swiper-slide>
                          </swiper>
                         
                        </div>
                    </div>
                </div>
                <div class="inSpecialProductRight">
                     <div class="imgBox"><img src="./images/01.jpg" /></div>
                    <div class="title2">{{isZhong?'TEC传感器':'TEC SENSORS'}}</div>
                    <div class="title1Box" v-if="productList && productList.length>0">
                        <!-- <div class="swiper-pagination2"></div> -->
                        <router-link :to='`/products/productdetail/${item.contentid}`' class="title1Item" v-for="(item,index) in productList" :key="item.contentid" @mouseenter.native="changeSwiper(index)">{{item.title}}</router-link>

                    </div>
                </div>
            </section>
         
    </div>
</template>
<script>
import BannerIn from '../../../components/BannerIn/BannerIn'
import NavIn from '../../../components/NavIn/NavIn'
import Footer from '../../../components/Footer/Footer'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

import { getList,getSort,getNav } from '../../../api'
export default {
  components:{
      swiper,
      swiperSlide,
      BannerIn,
      NavIn,
      Footer
  },
  data(){
    return{
        
        specialSwiperOption: {
            loop: true,　　//是否自动轮播
　　　　　　 autoplay: false,  //l轮播间隔时间
  　　　　　 navigation: {
                nextEl: '.bannerSwiperRight',
                prevEl: '.bannerSwiperLeft',
            },
            speed:1200,
            followFinger : false,
            mousewheel: true,
            slidesPerView: 'auto',
            // pagination: {
            //     el: '.swiper-pagination2',
            //     dynamicBullets: true,
            //     dynamicMainBullets: 1,
            //     clickable: true,
              
            //     renderBullet: (index, className)=> {
            //           var text;
            //           var pagination_title=['2021-18','2021-06','2021-05','2021-04','2021-03','2021-02'];

            //           switch(index){
            //             case index:text=pagination_title[index];break;
            //           }
            //           return '<a class="' + className + '">' + text + '</a>';
            //     }
            // },
　　　　 },
        bannerUrl:'' ,
        inNavInfo:[
            {
                title:'Automatic Baling Machine',
                url:'#',
                selected:true
            },
            {
                title:'Spraying Marking Machine',
                url:'#',
                selected:false
            },
            {
                title:'TEC Sensor',
                url:'#',
                selected:false
            }
        ],
        positionInfo:{
            second:'PRODUCTS',
            third:'Automatic Baling Machine'
        },
        productList:[],
        tanClicked:false,
        tanPics:[],
        isZhong:false
    }
  },
   created(){
      this.updateData();
  },
  mounted(){
  },
 
  methods:{
    changeTanStatus(status,contentid){
      const productList = this.productList;
      let tanPics = [];
      let defaultIco = '';
      if(contentid){
          let tanPicsSingleArr = productList.filter(v=>v.contentid==contentid);
          if(tanPicsSingleArr){
            let tanPicsString = tanPicsSingleArr[0].pics;
            defaultIco = tanPicsSingleArr[0].ico;
            if(tanPicsString){//如果有多图
               tanPics = tanPicsString.split(',');
            }
            tanPics.unshift(defaultIco);
            this.tanPics = tanPics;
          }
      }
      //获取tanPics的数据并转换为数组
      // const selectedid = contentid; 
      //更新tanClicked状态，控制显示隐藏
      this.tanClicked = status;
    },
    async updateData(){

      const isZhong = this.$parent.isZhong;
      let resNav;
      let positionInfo = {};
      let res;
      if(isZhong){
          resNav = await getNav(43);
          res = await getList(46);
          positionInfo={
              second:'产品中心',
              third:''
          }
      }else{
          resNav = await getNav(5);
          res = await getList(12);
          positionInfo={
              second:'PRODUCTS',
              third:''
          }
      }
      this.positionInfo = positionInfo;
      this.isZhong = isZhong; 


      //二级分类
      let inNavInfo = resNav.data.map(v=>{
          return{
              title:v.name,
              url:'/products/productlist/'+v.scode,
              selected:false
          } 
      })
      
      inNavInfo.forEach(v=>v.url==this.$route.path?v.selected=true:v.selected=false);
      this.inNavInfo=inNavInfo;
      //更新产品列表

      
      this.productList = res.data;
       //更新bannerIn
       const res2 = await getSort(5);
       this.bannerUrl = res2.data.pic;
       
    },
    changeSwiper(index){
      this.$refs.special.swiper.slideTo(index);
      console.log(index)
    }

  }

}
</script>

<style lang="scss" scoped>
@import '../../../common/css/mixin.scss';
.inProduct_list{
  height: 100%;
}
.inSpecialProductBox {
  background: url(./images/beijing01_def.jpg) no-repeat;
  background-size: cover;
  padding: 66px 0 122px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  .inSpecialProductLeft {
    width: 58%;
    .title1 {
      line-height: 36px;
      text-align: center;
      height: 36px;
      overflow: hidden;
    }
    .title2 {
      line-height: 52px;
      text-align: center;
      height: 52px;
      overflow: hidden;
      font-size: 32px;
      font-weight: bold;
    }
    .imgBox {
      margin: 32px 0 0 0;
      position: relative;
      width: 100%;
      .imgBg {
        width: 100%;
        img {
          width: 102%;
          max-width: initial;
          clip-path: polygon(0% 0%, 0% 0%, 100% 0%, 83% 100%, 0% 100%, 0% 0%, 0% 0%);
        }
      }
      .img {
        position: absolute;
        bottom: -100px;
        left: 0;
        width: 100%;
        .specialSwiper_item{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        img {
          width: 50%;

        }
      }
    }
  }
  .inSpecialProductRight {
    width: 42%;
    .imgBox {
      margin: 22px 0 0 0;
      width: 100%;
      img {
      width: 102%;
      max-width: initial;
      clip-path: polygon(0% 0%, 0% 0%, 100% 0%, 100% 100%, 0% 100%, 12% 0%, 0% 0%);

      }
    }
    .title2 {
      line-height: 52px;
      text-align: center;
      height: 52px;
      overflow: hidden;
      font-size: 32px;
      font-weight: bold;
      margin: 22px 0 0 0;

    }
    .title1Box {
      margin-top: 22px;
      .title1Item {
        height: 36px;
        line-height: 36px;
        padding-bottom: 2px;
        font-size: 16px;
        margin-bottom: 28px;
        margin-right: 55px;
        display: inline-block;
        &.active{
          border-bottom: 1px solid #e70212;
        }
        &:hover{
          color:#e70212;
          border-bottom: 1px solid #e70212;
        }

      }
    }
  }
  
}

* {
  -webkit-box-sizing: border-box; /* Safari<=5 Android<=3 */
  -moz-box-sizing: border-box; /* <=28 */
  box-sizing: border-box;
}
/* Custom
 * --------------------------------------- */
.swiper-slide {
    transition:all 1.6s;
    transform: scale(0.6);
}
.swiper-slide-active,.swiper-slide-duplicate-active{
    transform: scale(1);
}

</style>
 


// WEBPACK FOOTER //
// src/pages/Products/ProductList/ProductSpecialList.vue